module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tiktok-options"
  }, [_c('el-form', {
    attrs: {
      "model": _vm.settings,
      "label-position": "top",
      "size": "small"
    }
  }, [_c('el-form-item', [(_vm.loading) ? [_c('el-skeleton', {
    attrs: {
      "rows": 1,
      "animated": ""
    }
  })] : [_c('el-avatar', {
    attrs: {
      "src": _vm.settings.creator_avatar_url,
      "size": "small"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "creator-label"
  }, [_vm._v("Posting as: ")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.settings.creator_nickname || _vm.settings.creator_username))])]], 2), _vm._v(" "), _c('el-divider'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Who can view this video"
    }
  }, [(_vm.loading) ? [_c('el-skeleton', {
    attrs: {
      "rows": 1,
      "animated": ""
    }
  })] : [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "Select visibility...",
      "clearable": ""
    },
    model: {
      value: (_vm.settings.privacy_level),
      callback: function($$v) {
        _vm.$set(_vm.settings, "privacy_level", $$v)
      },
      expression: "settings.privacy_level"
    }
  }, _vm._l((_vm.privacyOptions), function(option) {
    return _c('el-option', {
      key: option.value,
      attrs: {
        "label": option.label,
        "value": option.value
      }
    })
  }), 1)]], 2), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Allow users to"
    }
  }, [(_vm.loading) ? [_c('el-skeleton', {
    attrs: {
      "rows": 1,
      "animated": ""
    }
  })] : [_c('el-switch', {
    attrs: {
      "active-text": "Comment"
    },
    model: {
      value: (_vm.settings.allow_comment),
      callback: function($$v) {
        _vm.$set(_vm.settings, "allow_comment", $$v)
      },
      expression: "settings.allow_comment"
    }
  }), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "Duet"
    },
    model: {
      value: (_vm.settings.allow_duet),
      callback: function($$v) {
        _vm.$set(_vm.settings, "allow_duet", $$v)
      },
      expression: "settings.allow_duet"
    }
  }), _vm._v(" "), _c('el-switch', {
    attrs: {
      "active-text": "Stitch"
    },
    model: {
      value: (_vm.settings.allow_stitch),
      callback: function($$v) {
        _vm.$set(_vm.settings, "allow_stitch", $$v)
      },
      expression: "settings.allow_stitch"
    }
  })]], 2), _vm._v(" "), (!_vm.loading && _vm.settings.max_video_post_duration_sec) ? _c('el-alert', {
    staticClass: "max-duration-alert",
    attrs: {
      "type": "info",
      "closable": false,
      "show-icon": ""
    }
  }, [_vm._v("\n      Max video post duration: " + _vm._s(_vm.formatDuration(_vm.settings.max_video_post_duration_sec)) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "tiktok-terms"
  }, [_vm._v("\n      By posting, you agree to TikTok's\n      "), _c('a', {
    attrs: {
      "href": "https://www.tiktok.com/legal/page/global/music-usage-confirmation/en",
      "target": "_blank"
    }
  }, [_vm._v("Music Usage Confirmation")]), _vm._v(".\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-361a799f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/social/tiktok/TikTokOptions.vue
// module id = 3215
// module chunks = 3